export default [
  // Education
  {
    blenderName: "studies",
    name: "studiesskills",
    id: "card-studies-skills-container",
    posX: "-2.18",
    posY: "2",
    posZ: "0.247",
    rotY: "1.39",
    camPosX: "1.18",
    camPosY: "1.56",
    camPosZ: "1.19",
    orbPosX: "-2.22",
    orbPosY: "1.69",
    orbPosZ: "0.17",
  },
  //geochemistry experience
  {
    blenderName: "workexperience",
    name: "jobgeochemistry",
    id: "card-job-geochemistry",
    posX: "-2.03",
    posY: "2.1",
    posZ: "-0.7",
    rotY: "1.39",
    camPosX: "1.71",
    camPosY: "2.4",
    camPosZ: "-0.5",
    orbPosX: "-2.11",
    orbPosY: "1.53",
    orbPosZ: "-0.71",
  },
  //dream job
  {
    blenderName: "dreamjob",
    name: "newjob",
    id: "card-new-job",
    posX: "0.419",
    posY: "2.32",
    posZ: "-1.905",
    rotY: "0",
    camPosX: "0.24",
    camPosY: "1.4",
    camPosZ: "1.95",
    orbPosX: "0.41",
    orbPosY: "1.59",
    orbPosZ: "-2.07",
  },
  //photography
  {
    blenderName: "insta",
    name: "photography",
    id: "card-hobby-photograpgy",
    posX: "2.14",
    posY: "2.3",
    posZ: "-0.5",
    rotY: "-1.39",
    camPosX: "-1.39",
    camPosY: "1.22",
    camPosZ: "0.13",
    orbPosX: "2.38",
    orbPosY: "1.44",
    orbPosZ: "-0.54",
  },
  //wood working
  {
    blenderName: "woodworkingRay",
    name: "woodworking",
    id: "card-hobby-woodworking",
    posX: "2.44",
    posY: "1.279",
    posZ: "1.537",
    rotY: "-1.4",
    camPosX: "-0.81",
    camPosY: "1.13",
    camPosZ: "1.95",
    orbPosX: "2.5",
    orbPosY: "0.96",
    orbPosZ: "1.57",
  },
];
